import {areEqual} from "../common/NamaCommon";
import * as StringConstants from "../constants/StringConstants";

/**
 *
 * @param {namaTypes.EntityReferenceData} dim
 */
export function isNullDimension(dim)
{
    if (!dim)
        return false;
    return areEqual(dim.code, StringConstants.DIMENSION_NULL_CODE);
}
/**
 *
 * @param {namaTypes.EntityReferenceData} dim
 */
export function isNotNullDimension(dim)
{
    if (isNullDimension(dim))
        return false;
    return true;
}
